import { Chart, registerables } from "chart.js";
import { useEffect, useRef } from "react";

const ProductionChart = ({
    classes,
    productionData,
    productionData1,
    productionData2,
    productionData3,
    productionData4,
    productionData5,
    productionData6,
    productionData7,
    startDate,
    endDate,
    targetData,
}) => {
    const chartContainer = useRef(null);

    // Register all required Chart.js components
    Chart.register(...registerables);

    useEffect(() => {
        // Debugging logs to verify data
        console.log("Target Data:", targetData);
        console.log("Production Data:", productionData, productionData1, productionData2, productionData3, productionData4, productionData5);

        const barChartData = {
            // labels: [
            //     "Class 00",
            //     "Class 0",
            //     "Class 1",
            //     "Class 2",
            //     "Class 3",
            //     "Class 4",
            // ],
            labels: classes,
            datasets: [
                {
                    label: "Target",
                    backgroundColor: "#F6E163",
                    borderColor: "#F6E163",
                    borderWidth: 1,
                    data: [
                        targetData.class_00 || 0,
                        targetData.class_0 || 0,
                        targetData.class_1 || 0,
                        targetData.class_2 || 0,
                        targetData.class_3 || 0,
                        targetData.class_4 || 0,
                        targetData.class_5 || 0,
                        targetData.class_6 || 0,
                    ],
                },
                {
                    label: "Produced",
                    backgroundColor: "#1C407B",
                    borderColor: "#1C407B",
                    borderWidth: 1,
                    data: [
                        productionData?.produce || 0,
                        productionData1?.produce || 0,
                        productionData2?.produce || 0,
                        productionData3?.produce || 0,
                        productionData4?.produce || 0,
                        productionData5?.produce || 0,
                        productionData6?.produce || 0,
                        productionData7?.produce || 0,
                    ],
                },
                {
                    label: "Accepted",
                    backgroundColor: "#00AB66",
                    borderColor: "#00AB66",
                    borderWidth: 1,
                    data: [
                        productionData?.passed || 0,
                        productionData1?.passed || 0,
                        productionData2?.passed || 0,
                        productionData3?.passed || 0,
                        productionData4?.passed || 0,
                        productionData5?.passed || 0,
                        productionData6?.passed || 0,
                        productionData7?.passed || 0,
                    ],
                },
                {
                    label: "Rejected",
                    backgroundColor: "#E31E24",
                    borderColor: "#E31E24",
                    borderWidth: 1,
                    data: [
                        productionData?.rejected || 0,
                        productionData1?.rejected || 0,
                        productionData2?.rejected || 0,
                        productionData3?.rejected || 0,
                        productionData4?.rejected || 0,
                        productionData5?.rejected || 0,
                        productionData6?.rejected || 0,
                        productionData7?.rejected || 0,
                    ],
                },
            ],
        };

        const chartOptions = {
            maintainAspectRatio: false,
            responsive: true,
            plugins: {
                legend: {
                    display: false, // Display legend for all datasets
                },
            },
            scales: {
                x: {
                    grid: {
                        display: false,
                    },
                    ticks: {
                        font: {
                            size: 14,
                        },
                        color: "#001323",
                    },
                },
                y: {
                    grid: {
                        display: false,
                    },
                    ticks: {
                        beginAtZero: true,
                        font: {
                            size: 12,
                        },
                        color: "#001323",
                    },
                    title: {
                        display: true,
                        text: "Qty in Nos",
                        font: {
                            size: 17,
                            weight: "bold",
                        },
                        color: "#001323",
                    },
                },
            },
        };

        const ctx = chartContainer.current.getContext("2d");
        const chart = new Chart(ctx, {
            type: "bar",
            data: barChartData,
            options: chartOptions,
        });

        return () => {
            chart.destroy();
        };
    }, [
        productionData,
        productionData1,
        productionData2,
        productionData3,
        productionData4,
        productionData5,
        productionData6,
        productionData7,
        startDate,
        endDate,
        targetData,
    ]);

    return (

        <>
            <div class="tooltip-container tool1">
                <span class="tooltiptext">
                    {isNaN((100 * productionData.passed) / productionData.produce)
                        ? "-"
                        : (
                            (100 * productionData.passed) /
                            productionData.produce
                        ).toFixed(2) == "Infinity"
                            ? 0
                            : (
                                (100 * productionData.passed) /
                                productionData.produce
                            ).toFixed(2)}
                    % Yield
                </span>
            </div>
            <div class="tooltip-container tool2">
                <span class="tooltiptext">
                    {isNaN((100 * productionData1.passed) / productionData1.produce)
                        ? "-"
                        : (
                            (100 * productionData1.passed) /
                            productionData1.produce
                        ).toFixed(2) == "Infinity"
                            ? 0
                            : (
                                (100 * productionData1.passed) /
                                productionData1.produce
                            ).toFixed(2)}
                    % Yield
                </span>
            </div>
            <div class="tooltip-container tool3">
                <span class="tooltiptext">
                    {isNaN((100 * productionData2.passed) / productionData2.produce)
                        ? "-"
                        : (
                            (100 * productionData2.passed) /
                            productionData2.produce
                        ).toFixed(2) == "Infinity"
                            ? 0
                            : (
                                (100 * productionData2.passed) /
                                productionData2.produce
                            ).toFixed(2)}
                    % Yield
                </span>
            </div>
            <div class="tooltip-container tool4">
                <span class="tooltiptext">
                    {isNaN((100 * productionData3.passed) / productionData3.produce)
                        ? "-"
                        : (
                            (100 * productionData3.passed) /
                            productionData3.produce
                        ).toFixed(2) == "Infinity"
                            ? 0
                            : (
                                (100 * productionData3.passed) /
                                productionData3.produce
                            ).toFixed(2)}
                    % Yield
                </span>
            </div>
            <div class="tooltip-container tool5">
                <span class="tooltiptext">
                    {isNaN((100 * productionData4.passed) / productionData4.produce)
                        ? "-"
                        : (
                            (100 * productionData4.passed) /
                            productionData4.produce
                        ).toFixed(2) == "Infinity"
                            ? 0
                            : (
                                (100 * productionData4.passed) /
                                productionData4.produce
                            ).toFixed(2)}
                    % Yield
                </span>
            </div>
            <div class="tooltip-container tool6">
                <span class="tooltiptext">
                    {isNaN((100 * productionData5.passed) / productionData5.produce)
                        ? "-"
                        : (
                            (100 * productionData5.passed) /
                            productionData5.produce
                        ).toFixed(2) == "Infinity"
                            ? 0
                            : (
                                (100 * productionData5.passed) /
                                productionData5.produce
                            ).toFixed(2)}
                    % Yield
                </span>
            </div>

            <div style={{ width: "100%", height: "392px", padding: "30px" }}>
                <canvas ref={chartContainer}></canvas>
            </div>
        </>
    );
};

export default ProductionChart;
